import { register } from 'async-ops';
import { getDefaultOptions, throwExceptionErrors } from '../../../utils/fetch';
import { callMdaePublicApi } from "../../../call-web-api";

export const INSERT_BULK_DOCUMENT_DOWNLOAD_EVENT = 'INSERT_BULK_DOCUMENT_DOWNLOAD_EVENT';

export const service = async (data) => {
    const response: any = await callMdaePublicApi({
        type: 'post',
        contentType: 'application/json',
        url: '/Api/Document/InsertBulkDocumentEvent',
        isRoutedApiCall: true,
        ...getDefaultOptions(),
        body: JSON.stringify(data)
    })
    throwExceptionErrors(response);
    return response;

};

const mockData = () => {
    return ([])
};

const mock = () => Promise.resolve(mockData());

register(INSERT_BULK_DOCUMENT_DOWNLOAD_EVENT, service, mock);
